export const getItemsWithNoJackpotCached = <
  T extends { jackpotCode?: string },
  JP extends { [key: string]: unknown }
>(
  items: T[],
  currentJackpots: Record<string, JP>
) =>
  items.filter(({ jackpotCode }) => {
    const jpValues = Object.values(currentJackpots);
    return (
      !jpValues.length ||
      jpValues.some(provider => jackpotCode && !provider[jackpotCode])
    );
  });
